import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(
    ActionType.NOTI__EC__RESET,
);
